import React from "react";
import { Box, makeStyles, Tooltip } from "@material-ui/core";
import { CreateCSSProperties } from "@material-ui/core/styles/withStyles";
import AddIcon from '@material-ui/icons/Add';
import { useState } from "react";
import { Events } from "./Constants";
interface SwitchVariantProps {
    uniqueExperiences : string[],
    handleChildEvent: (userEvent:any) => void,
    currentExperienceId: string,
    createDeviceVariant: (isBreakpointAlreadyCreated: boolean) => void,
    baseExperience: boolean,
    baseExperienceId: string
}

const useStyles = makeStyles<CreateCSSProperties>(() => ({
    boxStyles: { 
        display: "flex", 
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row"
    },
    plusIcon:{
        color: "#868686",
        cursor: "pointer",
        '&:hover': {
            color: '#ffffff'
        }
    },
    variantIcon: {
        display: "flex",
        position: "relative",
        width: "26px",
        height: "26px",
        cursor: "pointer",
        padding: "2px",
        textAlign: "center",
        border: "1px", 
        borderStyle: "solid", 
        borderColor:"#868686", 
        justifyContent: "center",
        alignItems: "center",
        color: "#868686",
        margin: "4px",
        '&:hover': {
            borderColor: '#ffffff',
            color: '#ffffff'
        }
    },
    selected: {
        borderColor: '#ffffff',
        color: '#ffffff'
    },

    tooltipPopper: {
        width: "200px !important",
        borderRadius: '1px',
        backgroundColor: '#fff',
        top: "5px !important"
    },

    tooltipLabel: {
        backgroundColor: '#fff',
        height: "54px",
        fontSize: "1rem",
        fontWeight: 500,
        color: 'black',
        margin: "0px",
        "& .MuiTooltip-arrow": {
            color: "#fff",
            "&:before": {
                border: "1px solid #343e43"
            },
        }
    }
  }));

const BaseExpTooltipText = () => (
    <p
        style={{
            textAlign: "center",
        }}
    >
        Changes made to this experience would be automatically reflected in all other variants and breakpoints
        combinations.
    </p>
);

export default function SwitchVariant(props: SwitchVariantProps) {

    const { uniqueExperiences, currentExperienceId, handleChildEvent, createDeviceVariant, baseExperience, baseExperienceId } = props;
    const classes = useStyles();
    const [hoveredIndex, setHoveredIndex] = useState<number | undefined>(undefined);

    const changeVariant = (mouseEvent: React.MouseEvent) => {
        const userEvent = {
            event: Events.SWITCH_VARIANT,
            variantExperienceId: mouseEvent.currentTarget.getAttribute("data-experience-id")
        };
        handleChildEvent(userEvent);
    };

    const deleteVariant = (mouseEvent:any, experienceId: string) => {
        const userEvent = {
            event: Events.DELETE_VARIANT,
            variantExperienceId: experienceId,
            currentExperienceId: currentExperienceId
        }
        mouseEvent.stopPropagation();
        handleChildEvent(userEvent);
    };

    const generateVariantIcon = (experienceId: string, index: number) => {
        const favIconStyle = {
            position: "absolute",
            width: "1.4rem",
            height: "1.4rem",
            top: "-0.7rem",
            left: "-0.7rem",
        } as React.CSSProperties;
        let favIcon = false;
        if (experienceId === baseExperienceId) favIcon = true;
        return (
            <Tooltip
                classes={{
                    popper: classes.tooltipPopper,
                    tooltip: classes.tooltipLabel,
                }}
                arrow
                title={favIcon ? <BaseExpTooltipText /> : ""}
                TransitionProps={{ timeout: 0 }}
            >
                <div
                    onClick={(e) => changeVariant(e)}
                    data-experience-id={experienceId}
                    className={
                        experienceId === currentExperienceId
                            ? `${classes.variantIcon} ${classes.selected}`
                            : classes.variantIcon
                    }
                    key={index}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(undefined)}
                >
                    {favIcon && <img src="../../../../images/icons/star.png" style={favIconStyle} />}
                    <span
                        onClick={(e) => deleteVariant(e, experienceId)}
                        style={{
                            display: baseExperience ? (hoveredIndex === index ? "block" : "none") : "none",
                            position: "absolute",
                            top: "-7px",
                            right: "-7px",
                            lineHeight: "14px",
                            width: "14px",
                            fontSize: "19px",
                            textAlign: "center",
                            color: "white",
                            borderRadius: "50%",
                            backgroundColor: "#808080",
                        }}
                    >
                        &#215; 
                    </span>
                    <span>#{index+1}</span>
                </div>
            </Tooltip>
        );
    };

    return (
        /* @ts-ignore */
        <Box className={classes.boxStyles}>
            {uniqueExperiences.map((experienceId, index) => {
                return generateVariantIcon(experienceId, index);
            })}
            {baseExperience ? (
                <AddIcon fontSize="large" onClick={() => createDeviceVariant(true)} className={classes.plusIcon} />
            ) : (
                ""
            )}
        </Box>
    );
}


// WEBPACK FOOTER //
// ./src/editor/ui/editor/CollectionNavigation/SwitchVariant.tsx